var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.829,
    height: 21.211,
    viewBox: "0 0 17.829 21.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20458",
    "data-name": "Caminho 20458",
    className: "cls-1",
    d: "M16.77,23.642A3.163,3.163,0,0,0,19.926,20.7l.965-13.873h.326a.863.863,0,1,0,0-1.725H5.113a.863.863,0,0,0,0,1.725h.326L6.4,20.7a3.163,3.163,0,0,0,3.156,2.944ZM8.125,20.579a1.438,1.438,0,0,0,1.434,1.338H16.77A1.438,1.438,0,0,0,18.2,20.579l.957-13.754H7.168Z",
    transform: "translate(-4.25 -2.431)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20459",
    "data-name": "Caminho 20459",
    className: "cls-1",
    d: "M8.25,3.643a.863.863,0,0,1,.863-.863h6.9a.863.863,0,1,1,0,1.725h-6.9A.863.863,0,0,1,8.25,3.643Z",
    transform: "translate(-3.649 -2.78)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.b8c537577db4f58686ecc8a988273c2e.svg";
export { ForwardRef as ReactComponent };